import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import { StoreService } from './store.service';

@Injectable()
export class LanguageInterceptorService implements HttpInterceptor {


    constructor(private storeService: StoreService) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        const rest_backend = environment.rest_backend;
        const originalUrl = req.url;

        if (originalUrl.includes(rest_backend)) {
            const storeCode = this.storeService.getStoreCode()
            console.log("Selected store code", storeCode)
            const languageBackend = environment.rest_backend + '/' + storeCode;
            const newUrl = originalUrl.replace(rest_backend, languageBackend);

            console.log(`new url is ${newUrl}`);
            req = req.clone({url: newUrl});
        }

        // only handly rest backend

        console.log(req);
        return next.handle(req);
    }

}
